import { ssmMessageService } from './message-service';

export default class LoadingService {

    private loadingCount: number;

    constructor() {
        this.loadingCount = 0;
    }

    public enableLoading() {
        if (!this.isLoading()) {
            ssmMessageService.showLoading();
        }
        this.loadingCount++;
    }

    public disableLoading() {
        this.loadingCount--;
        if (!this.isLoading()) {
            ssmMessageService.hideLoading();
        }
    }

    public isLoading(): boolean {
        return this.loadingCount > 0;
    }

}

export const ssmLoadingService = new LoadingService();
